import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import { H2 } from 'foundations-components/transitional/components/H2';
import { H4 } from 'foundations-components/transitional/components/H4';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CapIcon, DealsIcon, SocialBlockLinkedinIcon, SprocketIcon } from 'foundations-assets';
import { View } from 'foundations-components/transitional/components/View';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Column = ({
  heading,
  description,
  icon
}) => {
  return /*#__PURE__*/_jsxs(Box, {
    maxInlineSize: "400px",
    children: [icon && /*#__PURE__*/_jsx(IconHolder, {
      color: "icon-core-subtle",
      icon: icon,
      padding: "0",
      size: "1000"
    }), /*#__PURE__*/_jsx(H4, {
      children: heading
    }), /*#__PURE__*/_jsx("p", {
      children: description
    })]
  });
};
const WhyLearnSection = () => {
  const {
    isNotTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    as: "section",
    backgroundColor: "fill-field-default",
    paddingBlock: "1200",
    textAlign: "center",
    children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "400",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(IconHolder, {
          color: "fill-primary-default",
          icon: SprocketIcon,
          padding: "0",
          size: "900"
        })
      }), /*#__PURE__*/_jsx(H2, {
        marginBlockEnd: "800",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.whyLearnSection.title"
        })
      }), /*#__PURE__*/_jsxs(TFlex, {
        columnGap: "1000",
        justify: "center",
        rowGap: "200",
        wrap: isNotTablet ? 'nowrap' : 'wrap',
        children: [/*#__PURE__*/_jsx(Column, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyLearnSection.advanceCareerDescription"
          }),
          heading: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyLearnSection.advanceCareer"
          }),
          icon: CapIcon
        }), /*#__PURE__*/_jsx(Column, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyLearnSection.showSkillsDescription"
          }),
          heading: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyLearnSection.showSkills"
          }),
          icon: SocialBlockLinkedinIcon
        }), /*#__PURE__*/_jsx(Column, {
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyLearnSection.growBusinessDescription"
          }),
          heading: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyLearnSection.growBusiness"
          }),
          icon: DealsIcon
        })]
      })]
    })
  });
};
export default WhyLearnSection;